import { State } from 'redux/initialState';
import { useSelector } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';

import menuTypes from 'constants/menuTypes';

import Page from 'modules/_shared/components/Pages/Page';
import PageWithTabs from 'modules/_shared/components/Pages/PageWithTabs';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';

import UserMyData from '../../components/UserMyData';

const UserProfile = () => {
  const { t } = useTranslate();

  const user = useSelector((state: State) => state.user);

  useGetMenu(menuTypes.MAIN);

  return (
    <Page>
      <PageListHeader
        title={t('MyProfile')}
        description={t('FromHereYouCanManageYourData')}
      />

      <PageWithTabs
        tabs={[
          {
            key: 'user-profile-data',
            icon: 'ni-user-fill-c',
            title: t('MyData'),
            content: user && <UserMyData user={user} key="UserMyData" />,
          },
        ]}
        isError={false}
        isLoading={!user}
      />

      {!user && <CustomLoading />}
    </Page>
  );
};

export default UserProfile;
